import { P2GButton, P2GLink } from '@parcel2go/core-ui';

interface props {
  download?: string;
  href?: string;
  target?: string;
  colour?: 'primary' | 'secondary';
  onClick?: (event: React.MouseEvent<HTMLElement>) => Promise<void> | void;
  variant: 'button' | 'link';
  disabled?: boolean;
  id?: string;
  size?: 'large' | 'medium';
  children: React.ReactNode;
}
const LinkButton: React.FC<props> = (props) => {
  return (
    <a
      download={props.download}
      href={props.href}
      target={props.target}
      style={{ textDecoration: 'none' }}
      id={props.id}
    >
      {props.variant === 'button' ? (
        <P2GButton onClick={props.onClick} variant={props.colour} disabled={props.disabled} size={props.size}>
          {props.children}
        </P2GButton>
      ) : (
        <P2GLink onClick={props.onClick}>{props.children}</P2GLink>
      )}
    </a>
  );
};
export default LinkButton;
